document.querySelectorAll(".qty-minus")
.forEach(btn => {

  btn.addEventListener("click", () => {

    const input =
      btn.parentElement.querySelector("input");

    if (Number(input.value) > 1) {

      input.value =
        Number(input.value) - 1;

      document.getElementById(
        "fxCartForm"
      ).submit();

    }

  });

});

document.querySelectorAll(".qty-plus")
.forEach(btn => {

  btn.addEventListener("click", () => {

    const input =
      btn.parentElement.querySelector("input");

    input.value =
      Number(input.value) + 1;

    document.getElementById(
      "fxCartForm"
    ).submit();

  });

});